// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"d77b5014652d2608","3334":"482c58c647f90404","5045":"482c58c647f90404"}[chunkId] + ".css";
};